import { RootState } from '../../../../init-store';
import { DataPoint, DiagnosticsMessage } from './types';

export const selectLastMessage = (state: RootState): Maybe<DiagnosticsMessage> => {
    return state.diagnostics.messages[state.diagnostics.messages.length - 1];
};

export const selectDiagnosticsSectionActive = (state: RootState): boolean => {
    return state.diagnostics.messages.length > 0;
};

type DataPointsSelector = (state: RootState) => DataPoint[];

export const selectBitrateDataPoints: DataPointsSelector = (state) =>
    state.diagnostics.messages.map((m) => ({
        value: m.bitrate,
        timestamp: m.timestamp,
    }));

export const selectPacketLossDataPoints: DataPointsSelector = (state) =>
    state.diagnostics.messages.map((m) => ({
        value: m.packetLoss,
        timestamp: m.timestamp,
    }));

export const selectCpuLoadDataPoints: DataPointsSelector = (state) =>
    state.diagnostics.messages.map((m) => ({
        value: m.cpuLoad,
        timestamp: m.timestamp,
    }));

export const selectRttDataPoints: DataPointsSelector = (state) =>
    state.diagnostics.messages.map((m) => ({
        value: m.rtt,
        timestamp: m.timestamp,
    }));
